export default "__VITE_ASSET__BI2cje_t__"